module.exports = __webpack_public_path__ + "media/images/pc/top/area_brand_tvb@2x-e543d6db685b08cf256ee02a41d5c214.webp";